module.exports = __webpack_public_path__ + "fonts/RobotoBoldItalic.c783051f.ttf";